import { IUserData } from "../model_data";
import UserDataManager from "../../../manager/user_manager";
import EventManager from "../../../manager/event_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ComponentBase extends cc.Component{

    private mEventCallback: object
    private m_callbackMap 
    private m_maxId = 0
    getUserData(uid: number, callback : (data : IUserData)  => void, useNewData?: boolean){
        UserDataManager.getData(uid, (data)=>{
            if(this && this.isValid){
                callback && callback(data)
            }
        }, useNewData)
    }


    //真实时间的调用，就算界面被隐藏也将继续
    doSchedule(callback: Function, interval?: number, repeat?: number, delay?: number) {
        this.m_callbackMap = this.m_callbackMap ? this.m_callbackMap : {}
        let self = this
        let id = ++this.m_maxId
        let tmpFun = function () {
            if (!repeat) {
                self.cancelSchedule(id)
            }
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.schedule(tmpFun, interval, repeat, delay)
        return id
    }

    //真实时间的调用，就算界面被隐藏也将继续
    doScheduleOnce(callback: Function, delay: number) {
        this.m_callbackMap = this.m_callbackMap ? this.m_callbackMap : {}
        let id = ++this.m_maxId
        let tmpFun = function () {
            this.m_callbackMap[id.toString()] = null
            callback()
        }
        this.m_callbackMap[Number(id)] = tmpFun
        this.scheduleOnce(tmpFun, delay)
        return id
    }


    cancelSchedule(id: number) {
        if (this.m_callbackMap) {
            let key = id.toString()
            let callback = this.m_callbackMap[key]
            if (callback) {
                this.unschedule(callback)
                this.m_callbackMap[key] = null
            }
        }

    }

    cancelAllSchedule(){
        if(!this.m_callbackMap){
            return
        }
        for (const key in this.m_callbackMap) {
            if (this.m_callbackMap.hasOwnProperty(key)) {
                const callback = this.m_callbackMap[key];
                if (callback) {
                    this.unschedule(callback);
                    this.m_callbackMap[key] = null;
                }
            }
        }

        delete this.m_callbackMap;
    }


    eventDispatch(eventName: string, ...data) {
        return EventManager.instance.dispatch(eventName, ...data)
    }

    eventBind(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = callback
        EventManager.instance.on(eventName, callback, this, true)
    }

    //新增了绑定事件，只会触发调用一次就会自动回收
    eventBindOnce(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = callback
        EventManager.instance.on(eventName, callback, this, true, true)
    }

    eventUnBind(eventName: string, callback: Function) {
        this.mEventCallback = this.mEventCallback ? this.mEventCallback : {}
        this.mEventCallback[eventName] = null
        EventManager.instance.off(eventName, callback, this)
    }

    protected unBindAllEvent(){
        for (const key in this.mEventCallback) {
            if (this.mEventCallback.hasOwnProperty(key)) {
                const callback = this.mEventCallback[key];
                EventManager.instance.off(key, callback, this)
            }
        }
    }

    onDestroy(){
        this.cancelAllSchedule()
        this.unBindAllEvent()
    }
}